import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC, ReactNode } from 'react';

interface StatusTagProps {
  label: string;
  icon?: ReactNode;
  value?: boolean;
}

const StatusTag: FC<StatusTagProps> = ({ icon, value, label }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(s.wrapper, { [s.active]: value })}>
      {icon}
      <p className={s.label}>{label}</p>
      <span className={s.flag}>
        {value ? t('controls.yes') : t('controls.no')}
      </span>
    </div>
  );
};
export default StatusTag;
